<p-dialog [(visible)]="display" [resizable]="true" [modal]="true" [style]="{'width': '480px'}"
	(onHide)="hide()" appendTo="body" styleClass="prtg-group-picker-dialog">
	<p-header>
		<span>{{ title }}</span>
	</p-header>

	@if (loading) {
	<div class="mb-2">Loading PRTG groups…</div>
	}

	@if (errorMessage) {
	<div class="mb-2 text-danger">{{ errorMessage }}</div>
	}

	@if (!loading && !errorMessage && treeNodes.length > 0) {
	<p-tree [value]="treeNodes" selectionMode="single" [(selection)]="selectedNode"
		(onNodeDblclick)="onNodeDoubleClick()" styleClass="prtg-group-tree"></p-tree>
	}

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="select()" label="Select"
			[disabled]="!enableSelect"></button>
		<button type="button" pButton icon="fa fa-close" (click)="cancel()" label="Cancel"></button>
	</p-footer>
</p-dialog>
